import React from 'react';
import PropTypes from 'prop-types';
import escapeRegExp from 'lodash/escapeRegExp';
import {ASC, DESC} from 'src/pages/localChannelLineup/constants/lineupOrder';
import DefaultImg from 'src/img/channels/channel.png';

export const addDefaultSrc = event => event.target.src = DefaultImg;

export const ChannelLineup = ({
  channels,
  channelsError,
  filter,
  lineupOrder,
}) => {
  let lineup = channels;
  if (filter) {
    lineup = lineup.filter(({channelName}) => (new RegExp(`${escapeRegExp(filter)}`, 'i')).test(channelName));
  }
  if (lineupOrder === DESC) {
    lineup = lineup.slice().reverse();
  }
  return (
    <table>
      <thead>
        <tr>
          <th>Channel Number</th>
          <th aria-hidden="true"></th>
          <th>Channel Name</th>
        </tr>
      </thead>
      <tbody>
        {
          lineup.length && !channelsError
            ? lineup.map(({
              channelNumber,
              channelName,
              logoUrl,
            }) =>
              <tr key={channelNumber}>
                <td>{channelNumber}</td>
                <td aria-hidden="true"><img src={logoUrl} alt="" onError={addDefaultSrc} /></td>
                <td data-notranslate="true">{channelName}</td>
              </tr>
            )
            : (
              <tr>
                <td colSpan="3">{channelsError ? 'Sorry, we were unable to find a channel lineup at that address.' : filter && <>We&apos;re sorry, we are unable to find a channel with that name.</>}</td>
              </tr>
            )
        }
      </tbody>
    </table>
  );
};

ChannelLineup.propTypes = {
  channels: PropTypes.arrayOf(PropTypes.shape({
    channelNumber: PropTypes.number,
    channelName: PropTypes.string,
    logoUrl: PropTypes.string,
  })),
  channelsError: PropTypes.bool.isRequired,
  filter: PropTypes.string.isRequired,
  lineupOrder: PropTypes.oneOf([ASC, DESC]),
};
